import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import RestoreModal from 'email-management-lib/EmailRestore/components/RestoreModal';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import { useState } from 'react';
import PermanentlyDeleteModal from 'email-management-lib/EmailArchiveOrDelete/components/PermanentlyDeleteModal';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import useHasAllScopes from 'messaging-management-lib/user/hooks/useHasAllScopes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function DeletedViewHoverActions({
  crmObject
}) {
  const [isRestoreModalOpen, setIsRestoreModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const hasAllScopes = useHasAllScopes();
  const isSuperAdmin = hasAllScopes('super-admin');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ButtonWrapper, {
      "data-test-id": "deleted-view-hover-actions",
      children: [/*#__PURE__*/_jsx(Button, {
        size: "extra-small",
        use: "tertiary-light",
        onClick: () => setIsRestoreModalOpen(true),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.actions.names.restore"
        })
      }), /*#__PURE__*/_jsx(Tooltip, {
        disabled: isSuperAdmin,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.permanentlyDeleteTooltip"
        }),
        children: /*#__PURE__*/_jsx(Button, {
          size: "extra-small",
          use: "tertiary-light",
          disabled: !isSuperAdmin,
          onClick: () => setIsDeleteModalOpen(true),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management.actions.names.permanentlyDelete"
          })
        })
      })]
    }), isRestoreModalOpen && /*#__PURE__*/_jsx(RestoreModal, {
      crmObjects: [crmObject],
      onClose: () => setIsRestoreModalOpen(false),
      listingLibObserver: listingLibObserver
    }), isDeleteModalOpen && /*#__PURE__*/_jsx(PermanentlyDeleteModal, {
      crmObjects: [crmObject],
      onClose: () => setIsDeleteModalOpen(false)
    })]
  });
}
export default DeletedViewHoverActions;